import React from 'react';

const YogyismLogoSvg = ({ width = "100%", height = "100%", color = "#FFFFFF", ...props }) => {
return (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    // Adjusted viewBox: -10 -10 will shift the origin, and +20 to width/height
    // will expand the canvas by 10 units on each side.
    viewBox="-10 -10 358 260" // Original viewBox was "0 0 338 240"
    preserveAspectRatio="xMidYMid meet" // Keep 'meet' to ensure it fits and maintains aspect ratio
    {...props}
  >
    <g
      transform="translate(0.000000,240.000000) scale(0.100000,-0.100000)"
      fill={color}
      stroke="none"
    >
      <path d="M10 2390 c0 -22 54 -95 107 -144 30 -28 62 -70 73 -93 22 -51 47 -65
98 -57 29 5 50 1 83 -16 56 -29 156 -105 169 -130 29 -55 156 -114 385 -180
83 -24 177 -56 210 -73 70 -34 180 -141 245 -237 65 -95 108 -138 166 -166 95
-45 128 -109 106 -211 -6 -28 -36 -115 -66 -191 -73 -183 -74 -237 -9 -384 28
-62 23 -84 -19 -90 -12 -2 -30 -18 -40 -36 -18 -33 -18 -34 1 -60 10 -15 22
-37 26 -50 7 -23 6 -23 -28 -9 -31 14 -37 13 -66 -5 -74 -47 -39 -118 81 -161
110 -41 444 -96 489 -82 46 15 47 79 2 210 -28 85 -82 175 -136 232 l-41 42
55 58 c35 38 72 93 104 157 l50 98 -1 97 c-1 77 -10 127 -43 256 -23 88 -53
184 -67 214 -13 29 -24 55 -24 57 0 2 16 4 35 4 19 0 43 4 53 9 9 4 44 21 77
36 139 63 382 225 489 325 77 72 239 189 408 293 80 50 161 81 285 111 39 10
79 26 88 36 16 17 15 19 -6 30 -47 26 -79 29 -125 13 -37 -12 -65 -14 -133 -8
-153 13 -140 16 -188 -47 -55 -71 -84 -89 -208 -123 -157 -43 -251 -92 -349
-184 -92 -87 -59 -74 -313 -127 -43 -9 -140 -38 -216 -65 -77 -26 -146 -45
-155 -42 -44 16 -117 51 -222 108 -172 94 -266 128 -390 140 -53 5 -208 52
-315 95 -11 4 -51 20 -90 35 -63 25 -209 109 -428 246 -43 27 -82 49 -87 49
-4 0 -13 7 -20 15 -14 17 -100 21 -100 5z m1820 -2165 l23 -25 -42 0 -42 0 18
25 c10 13 18 25 19 25 0 0 11 -11 24 -25z"/>
    </g>
  </svg>
);
};

export default YogyismLogoSvg;